'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Bucket';

var EntypoBucket = function EntypoBucket(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M11,1C6.092,1,3.002,2.592,3.21,3.95c0.06,0.389,0.225,1.945,0.434,3.273c-2.405,0.934-3.202,2.449-3.095,3.684c0.127,1.461,1.441,3.025,4.328,3.295c1.648,0.154,3.631-0.75,4.916-2.295C9.671,11.7,9.6,11.457,9.6,11.2c0-0.774,0.627-1.4,1.4-1.4c0.774,0,1.4,0.627,1.4,1.4c0,0.762-0.61,1.381-1.369,1.398c-1.529,1.973-3.858,3.164-6.064,3.025c0.051,0.324,0.07,0.947,0.096,1.113C5.153,17.315,7.41,18.996,11,19c3.59-0.004,5.847-1.685,5.938-2.263C17.026,16.16,18.579,5.328,18.79,3.95C18.998,2.592,15.907,1,11,1z M1.943,10.785c-0.055-0.643,0.455-1.498,1.924-2.139c0.211,1.34,0.441,2.797,0.643,4.074C2.906,12.407,2.012,11.571,1.943,10.785z M11,6.024C7.41,6.022,4.863,4.69,4.863,4.192C4.861,3.698,7.41,2.402,11,2.404c3.59-0.002,6.139,1.294,6.137,1.788C17.137,4.69,14.59,6.022,11,6.024z' })
    );
};

exports.default = EntypoBucket;
module.exports = exports['default'];